import z from 'zod';

import { ForeclosureId } from '../BrandedIds';
import { zodJSInstantDate, zodJSPlainDate } from '../dates/BrandedDate';
import { OptionalPhoneNumber } from '../Phone';

// These outcomes came from Metro2 (credit reporting) specs
const ForeclosureOutcome = z.enum(['cancelled', 'reinstated', 'paidOff', 'completed']);

export const Foreclosure = z.object({
  id: ForeclosureId,
  referralDate: zodJSPlainDate,
  firstLegalActionDate: zodJSPlainDate.optional(),
  lawFirm: z.string().optional(),
  attorneyName: z.string().optional(),
  attorneyPhone: OptionalPhoneNumber,
  createdAt: zodJSInstantDate,
  updatedAt: zodJSInstantDate,
  /** date loan status changed out of foreclosure */
  endDate: zodJSInstantDate.optional(),
  /** outcome of foreclosure */
  endOutcome: ForeclosureOutcome.optional(),
  /** true if foreclosure was completed with a deficiency still owed to the lender */
  endDeficiencyOwedFlag: z.boolean().optional(),
});
export type Foreclosure = z.infer<typeof Foreclosure>;
